import React from 'react'

export default function Education() {
  return (
    <div className="condiv">
      <h1 className="subtopic">Education</h1>

      <div className="widecard">
        <div className="wide-con">
          <h3>Bachelor of Science: Information Technology</h3>
          <h4 className="secondtext">SUAN SUNANDHA RAJABHAT UNIVERSITY</h4>
          <h4 className="secondtext">jul 2017 - jun 2021</h4>
        </div>
      </div>
    </div>
  )
}
